import { page01Example } from '../../../../fixtures/page01/design-data';

/** Presentation-only sample seam. These types are NOT delivery/domain contracts. */
export type DemoState = 'ready' | 'loading' | 'empty' | 'unknown' | 'error' | 'stale' | 'planning';
export type ExampleEvent = (typeof page01Example.events)[number];
export type ExampleSuggestion = (typeof page01Example.suggestions)[number];
export interface Page01Snapshot {
  readonly source: 'LOCAL_VISUAL_EXAMPLE';
  readonly data: typeof page01Example;
  readonly events: readonly ExampleEvent[];
  readonly eventTotal: string;
  readonly assessment: 'example' | 'unknown';
  readonly warnings: 'ready' | 'error';
  readonly freshness: 'example' | 'stale';
  readonly lastRead: string;
}
export type Page01Read =
  { readonly status: 'loading' } | { readonly status: 'read'; readonly snapshot: Page01Snapshot };

export function demoStateFromSearch(search: string, development: boolean): DemoState {
  if (!development) return 'ready';
  const candidate = new URLSearchParams(search).get('state');
  switch (candidate) {
    case 'loading':
    case 'empty':
    case 'unknown':
    case 'error':
    case 'stale':
    case 'planning':
      return candidate;
    default:
      return 'ready';
  }
}

/** Deterministic fixture reader; no live-read fallback and no invented endpoint. */
export function readPage01Example(state: DemoState): Page01Read {
  if (state === 'loading') return { status: 'loading' };
  return {
    status: 'read',
    snapshot: {
      source: 'LOCAL_VISUAL_EXAMPLE',
      data: page01Example,
      events: state === 'empty' ? [] : page01Example.events,
      eventTotal: state === 'empty' ? '0' : page01Example.metrics[0].value,
      assessment: state === 'unknown' ? 'unknown' : 'example',
      warnings: state === 'error' ? 'error' : 'ready',
      freshness: state === 'stale' ? 'stale' : 'example',
      lastRead: '2024-11-15 09:42（示例）',
    },
  };
}

export function searchEvents(
  events: readonly ExampleEvent[],
  query: string,
): readonly ExampleEvent[] {
  const term = query.trim().toLocaleLowerCase();
  return events.filter((event) =>
    `${event.name} ${event.location} ${event.id}`.toLocaleLowerCase().includes(term),
  );
}
